/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bon-cancelled': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(7 8)" _stroke="#00272E"><path pid="0" d="M5.69 11.636h5.295"/><path pid="1" d="M13.11 14.545h-2.948"/><path pid="2" d="M8.523 2.91h1.416"/><path pid="3" d="M8.7 7.273h4.073"/><path pid="4" d="M8.7 5.09h4.073"/><path pid="5" d="M8.168 9.455h4.25"/><path pid="6" d="M7.124 0h8.836"/><path pid="7" d="M7.124 0c-.709 0-.726 1.09-.726 1.09s.079 6.51-.709 10.546H2.502C.73 11.636 2.856 16 .377 16H8.86c2.479 0 .354-4.364 2.125-4.364 1.77 0-.354 2.91 2.125 2.91S15.235 1.09 15.235 1.09 15.252 0 15.96 0c.415 0 .587.75.658 1.37a.74.74 0 01-.174.568.7.7 0 01-.53.244h-.662"/></g><g transform="translate(11 11)" _stroke="#00272E" stroke-width="1.1"><path pid="8" d="M0 11L11 0"/><path pid="9" d="M11 11L0 0"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/bon-cancelled.js